import { apiFetch } from '../utils/api';

/**
 * Fetches an active ViewConfig document by name (public).
 * @param {string} name
 */
export const getViewConfigByName = async (name) => {
  const response = await apiFetch(`/api/view-configs/${name}`);
  if (!response.ok) {
    throw new Error(`Failed to fetch view config: ${response.statusText}`);
  }
  return response.json();
};

/**
 * Fetches a ViewConfig document by name for admin (no isActive filter).
 * @param {string} name
 */
export const getViewConfigByNameAdmin = async (name) => {
  const response = await apiFetch(`/api/view-configs/admin/${name}`);
  if (!response.ok) {
    throw new Error(`Failed to fetch admin view config: ${response.statusText}`);
  }
  return response.json();
};

/**
 * Creates or updates a ViewConfig document (admin only).
 * @param {string} name
 * @param {Object} payload  — whitelisted fields sent to the backend
 */
export const upsertViewConfigAdmin = async (name, payload) => {
  const response = await apiFetch(`/api/view-configs/admin/${name}`, {
    method: 'PUT',
    body: JSON.stringify(payload),
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.message || `Failed to save view config: ${response.statusText}`);
  }
  return response.json();
};

